import React, { useImperativeHandle, useRef } from 'react'

import { IInputProps } from './InputComponent.types'
import {
  StyledError,
  StyledInput,
  Label,
  LabelContainer,
  HelperMessage,
} from './styles'

interface IInputValueProps {
  value: string
}

const Input: React.ForwardRefRenderFunction<IInputValueProps, IInputProps> = (
  {
    name,
    formControl,
    onChange,
    onPaste,
    onFocus,
    onBlur,
    mask,
    value,
    placeholder,
    errorMessage,
    type,
    disabled,
    label,
    className,
    maxLength,
    helperMessage,
    children,
  },
  ref,
) => {
  const inputRef = useRef(null)
  const isFormField = Boolean(formControl && name)
  const formFieldError = isFormField && name && formControl.errors[name]

  useImperativeHandle(ref, () => ({
    value: inputRef.current?.value,
  }))

  const handleChange = inputValue => {
    if (isFormField) {
      formControl.handleChange(name)(inputValue)
    }

    if (onChange) {
      onChange(inputValue)
    }
  }

  const handleBlur = () => {
    if (isFormField) {
      formControl.setFieldTouched(name, true)
    }

    if (onBlur) {
      onBlur()
    }
  }

  const inputValue = String(
    isFormField && name ? formControl.values[name] : value || '',
  )

  const inputMaskValue = String(
    mask
      ? isFormField && name
        ? mask(formControl.values[name])
        : mask(value)
      : '',
  )

  return (
    <>
      {label || helperMessage ? (
        <LabelContainer>
          {label && <Label>{label}</Label>}
          {helperMessage && <HelperMessage>{helperMessage}</HelperMessage>}
        </LabelContainer>
      ) : null}
      <StyledInput
        innerRef={inputRef}
        name={name}
        placeholder={placeholder}
        onChange={handleChange}
        onPaste={onPaste}
        onBlur={handleBlur}
        onFocus={onFocus}
        value={mask ? inputMaskValue : inputValue}
        type={type}
        disabled={disabled}
        className={className}
        autoComplete="off"
        maxLength={maxLength}
      />
      {children}
      {(isFormField && formFieldError?.message) || errorMessage ? (
        <StyledError>{errorMessage || formFieldError?.message}</StyledError>
      ) : null}
    </>
  )
}

export default React.forwardRef(Input)
